import { render, staticRenderFns } from "./heTrends.vue?vue&type=template&id=0fff9cd2&"
import script from "./heTrends.vue?vue&type=script&lang=js&"
export * from "./heTrends.vue?vue&type=script&lang=js&"
import style0 from "./heTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports